import React, { memo } from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { makeSelectEventTypeFilterDataArray, makeSelectEventTypeFilterId } from '../selectors';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import PillYellow, { PillText } from '../../../utils/Components/PillYellow';
import { setEventTypeFilterDataArray, setEventTypeFilterId } from '../actions';

const key = 'eventType';

export const FilterPills = ({
  eventTypeFilterId,
  eventTypeFilterDataArray,
  onSetEventTypeFilterId,
  onSetEventTypeFilterDataArray,
}) => {
  if (eventTypeFilterDataArray.length === 0) {
    return <></>;
  }

  const handlePillClick = (index) => {
    onSetEventTypeFilterId([...eventTypeFilterId.slice(0, index), ...eventTypeFilterId.slice(index + 1)]);
    onSetEventTypeFilterDataArray([
      ...eventTypeFilterDataArray.slice(0, index),
      ...eventTypeFilterDataArray.slice(index + 1),
    ]);
  };

  /**
   * Main return function.
   */
  return eventTypeFilterDataArray.map((item, index) => (
    <PillYellow key={`${key}_${item}`} onClick={() => handlePillClick(index)}>
      <PillText>{item}</PillText>
      <FontAwesomeIcon icon={faTimes} />
    </PillYellow>
  ));
};

FilterPills.propTypes = {
  eventTypeFilterId: PropTypes.array,
  eventTypeFilterDataArray: PropTypes.array,
  onSetEventTypeFilterId: PropTypes.func,
  onSetEventTypeFilterDataArray: PropTypes.func,
};

FilterPills.defaultProps = {
  eventTypeFilterId: [],
  eventTypeFilterDataArray: [],
  onSetEventTypeFilterId: () => {},
  onSetEventTypeFilterDataArray: () => {},
};

const mapStateToProps = createStructuredSelector({
  eventTypeFilterId: makeSelectEventTypeFilterId(),
  eventTypeFilterDataArray: makeSelectEventTypeFilterDataArray(),
});

export function mapDispatchToProps(dispatch) {
  return {
    onSetEventTypeFilterId: (value) => dispatch(setEventTypeFilterId(value)),
    onSetEventTypeFilterDataArray: (value) => dispatch(setEventTypeFilterDataArray(value)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, memo)(FilterPills);
